import getCleanedString from './getCleanedString';
import getDetailsEditableField from './getDetailsEditableField';
import getModifiedField from './getModifiedField';
import CardItem from 'txp-data/lib/schema/viewSchema/CardItem';

/**
 * This function generate the fields for the GWS body request
 */
export default function getRequestBodyFields(
    cardItem: CardItem,
    summaryEditableField: string,
    detailsEditableField: string
): { summaryEditableField: string; detailsEditableField: string } {
    let summaryModifiedField: string | null = getModifiedField(
        summaryEditableField,
        cardItem.summaryData.firstLine.text
    );
    let detailsModifiedField: string | null = getModifiedField(
        detailsEditableField,
        getDetailsEditableField(cardItem.detailsData)
    );

    return {
        summaryEditableField: getCleanedString(summaryModifiedField),
        detailsEditableField: getCleanedString(detailsModifiedField),
    };
}
